<template>
  <div id="container" v-if="fetch_contest">
    <section id="atsuatsu" class="list">
      <div class="wrap">
        <div class="cts_box">
          <h1 class="main_ttl"><span>{{ fetch_contest.contest.title }}</span></h1>

          <div class="body_tbl">
            <h3 class="min_ttl"><span>{{ $route.params.month }}ヶ月ランキング</span></h3>
            <p>総エントリー数：{{delimited(fetch_contest.contest.entry_count)}}名</p>
          </div>
          <div class="print_box flex">
            <a :href="`https://www.millioneyes.jp/medias/pdf/${contentCount()}_entrylist.pdf`" class="print_btn entry" target="_blank">エントリーリストPDF</a>
            <a :href="`https://www.millioneyes.jp/medias/pdf/${contentCount()}_${$route.params.month}result.pdf`" class="print_btn" target="_blank">最新ランキングPDF</a>
          </div>
        </div>

        <div class="box list" v-if="ranks">
          <div class="contest-status completed" v-if="completed">
            <span>確定</span>
          </div>
          <div class="contest-status progress" v-else>
            <span>進行中</span>
          </div>

          <div class="scrl_wrap">
            <table class="atsu_ranking_tbl" v-bind:class="`ranks-${$route.params.month}month`">
              <tbody>
              <tr>
                <th colspan="4" class="bdr_none">&nbsp;</th>
                <th v-bind:colspan="dates.length">株価</th>
                <th class="bdr_none">&nbsp;</th>
              </tr>
              <tr>
                <th>順位</th>
                <th>塾生番号</th>
                <th>銘柄コード</th>
                <th>銘柄名</th>
                <th v-for="date in dates" :key="'date-' + date">{{ date }}</th>
                <th>騰落率</th>
                <th>コメント</th>
              </tr>
              <tr v-for="m in ranks" :key="'list-12-' + m.user_number">
                <td class="rank-value">{{ m.rank && m.rank !== 10000 ? `${m.rank}` : '-' }}</td>
                <td class="number-value">
                  <template v-if="m.user_id">
                    <router-link :to="{ name: 'SnsTimeline', params: {user_id: m.user_id}}">
                      {{ Number(m.user_number) }}
                    </router-link>
                  </template>
                  <template v-else>
                    {{ Number(m.user_number) }}
                  </template>
                  <p class="comment_btn" @click="comment = m.comment">コメント</p>
                </td>
                <td class="ticker-value">
                  <a :href="'https://shikiho.toyokeizai.net/stocks/' + m.ticker" target="_blank">{{ m.ticker }}</a>
                </td>
                <td class="name-value">
                  <p><a :href="'https://shikiho.toyokeizai.net/stocks/' + m.ticker" target="_blank">{{ m.stock_name }}</a></p>
                </td>
                <td v-for="(p, index) in enablePrices(m)" :key="'price-' + index">{{ p && p.price ? delimited(p.price) : '-' }}</td>
                <td class="rate-value" v-bind:class="{plus: m.rate >= 0, minus: m.rate < 0}">
                  {{
                    m.rate === 0 ? '±' : m.rate >= 0 ? '+' : ''
                  }}{{ m.rate != null && m.rate !== -10000 ? (Math.round(m.rate * 100) / 100).toFixed(2) + '%' : '-' }}
                </td>
                <td class="comment-value">
                  {{ m.comment }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="cts_box">
          <div class="button_wrap mt20">
            <router-link :to="{name: 'AtsuatsuLp', query: {id: $route.params.id}}" class="submit arrow back light skeleton large">戻る</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- modal -->
    <div class="modal open" v-if="comment">
      <div class="modal_box">
        <div class="header">
          <h4>コメント</h4>
          <div class="close modal_close" @click="comment = null"></div>
        </div>
        <div class="inner draft cart">
          <div class="scroll_wrap">
            <div class="scroll_box">
              <div class="item_detail flex">
                {{ comment }}
              </div>
              <div class="btn_wrap">
                <a href="javascript:void(0)" @click="comment = null" class="submit light skeleton">閉じる</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ovr"></div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries],
  data() {
    return {
      atsuatsu_draft: this.$route.query.atsuatsu_draft,
      fetch_contest: null,
      ranks: null,
      completed: null,
      comment: null,
      dates: []
    }
  },
  watch: {
    '$route'() {
      this.atsuatsu_draft = this.$route.query.atsuatsu_draft
      this.fetch_contest = null
      this.ranks = null
      this.completed = null
      this.comment = null
      this.dates = []
      this.fetchStatic()
    }
  },
  mounted() {
    this.fetchContest()
  },
  methods: {
    contentCount() {
      const res = this.fetch_contest.contest.title.match(/\d+/)
      return (res ? res[0] : '??').padStart(4, '0')
    },
    enablePrices(m) {
      if (Number(this.$route.params.month) === 3) {
        m.prices.length = 4
      }
      return m.prices.filter((m) => { return m != null })
    },
    fetchContest() {
      this.startAjax()
      this.line_collections_3month = this.line_collections_12month = null
      this.axios
          .get(`${this.env.api_base_url}stock_contest/contest.json`, {
            params: {
              id: this.$route.params.id,
              draft: this.atsuatsu_draft,
              rank_count: null
            }
          })
          .then(response => {
            this.fetch_contest = response.data
            if (Number(this.$route.params.month) === 3) {
              this.ranks = this.fetch_contest.results.user_ranks_3month
              this.completed = this.fetch_contest.results.ranks_3month_completed
            } else {
              this.ranks = this.fetch_contest.results.user_ranks_12month
              this.completed = this.fetch_contest.results.ranks_12month_completed
            }

            if (this.ranks.length > 0) {
              this.dates = this.ranks[0].prices.filter((m) => { return m != null }).map((i) => {return i.date})
              if (Number(this.$route.params.month) === 3 && this.dates.length > 4) {
                this.dates.length = 4
              }
            }
            /*
            if (this.fetch_contest.results.stock_collections_3month) {
              let index = 0
              for (const m of this.fetch_contest.results.stock_collections_3month.datasets) {
                m.backgroundColor = colors[index]
                m.borderColor = colors[index++]
                m.lineTension = 0
                m.fill = false
              }
            }
            this.line_collections_3month = this.fetch_contest.results.stock_collections_3month

            if (this.fetch_contest.results.stock_collections_12month) {
              let index = 0
              for (const m of this.fetch_contest.results.stock_collections_12month.datasets) {
                m.backgroundColor = colors[index]
                m.borderColor = colors[index++]
                m.lineTension = 0
                m.fill = false
              }
            }
            this.line_collections_12month = this.fetch_contest.results.stock_collections_12month
            */
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },
  }
}
</script>

<style lang="scss">
.box {
  padding: 0 30px 0 30px;

  &.list {
    margin-bottom: 30px;

    .minus {
      color: red;
    }

    th, td {
      word-break: break-all;
    }

    th {
      &.rank {
        width: 10%;
      }

      &.number {
        width: 10%;
      }

      &.rate {
        width: 10%;
      }

      &.ticker {
        width: 10%;
      }

      &.name {
        width: 20%;
      }

      &.comment {
        width: 40%;
      }
    }
  }

  .contest-status {
    text-align: right;
    margin-bottom: 20px;
    color: white;

    span {
      display: inline-block;
      text-align: center;
      width: 100px;
      padding: 5px 10px 5px 10px;
      border-radius: 20px;
    }

    &.completed {
      span {
        background: red;
      }
    }

    &.progress {
      span {
        background: green;
      }
    }
  }
}
</style>
